import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import { AuthService } from "app/shared/auth/auth.service";
import { Utils } from "app/models/general/utils";
import { NavigatorService } from "app/shared/services/navigator.service";

@Component({
  selector: "app-full-layout",
  templateUrl: "./full-layout.component.html",
  styleUrls: ["./full-layout.component.scss"]
})
export class FullLayoutComponent {
  sidebarOpen = false;
  languageBusy = false;
  logoutBusy = false;
  navItems = [
    { key: "dashboard", route: "/dashboard", icon: "bi-speedometer2" },
    { key: "tasks", route: "/tasks", icon: "bi-kanban" },
    { key: "stock_products", route: "/stock-products", icon: "bi-box-seam" },
    { key: "invoices", route: "/invoices", icon: "bi-receipt" },
    { key: "service_requests", route: "/pages/service-requests", icon: "bi-briefcase" },
    { key: "sub_users", route: "/pages/sub-users", icon: "bi-people" },
    { key: "settings", route: "/pages/account-settings", icon: "bi-sliders" }
  ];
  accountItems = [
    { key: "profile", route: "/pages/profile", icon: "bi-person" },
    { key: "settings", route: "/pages/account-settings", icon: "bi-sliders" }
  ];

  languageOptions = [
    { code: "en", key: "language_english", flag: "en" },
    { code: "ka", key: "language_georgian", flag: "ka" },
    { code: "ru", key: "language_russian", flag: "ru" }
  ];
  activeLanguage = Utils.getLanguage();

  constructor(
    public auth: AuthService,
    private translate: TranslateService,
    private navigator: NavigatorService
  ) {}

  switchLanguage(lang: string) {
    if (this.languageBusy || this.activeLanguage === lang) {
      this.sidebarOpen = false;
      return;
    }

    this.languageBusy = true;
    this.activeLanguage = lang;
    Utils.setLanguage(lang);
    this.translate.use(lang);
    this.auth.saveLanguage(lang).subscribe({
      next: () => {
        this.languageBusy = false;
      },
      error: () => {
        this.languageBusy = false;
      }
    });
    this.sidebarOpen = false;
  }

  get currentLanguage() {
    return this.languageOptions.find((item) => item.code === this.activeLanguage) || this.languageOptions[0];
  }

  get shortcutNavItems() {
    return this.navItems.filter((item) => item.key !== "settings");
  }

  get displayName() {
    const name = `${this.auth.meObj?.first_name || ""} ${this.auth.meObj?.last_name || ""}`.trim();
    return name || this.auth.meObj?.email || "Account";
  }

  logout() {
    if (this.logoutBusy) {
      return;
    }

    this.logoutBusy = true;
    this.auth.logout().subscribe(() => {
      this.logoutBusy = false;
      this.navigator.toLogin();
    });
  }

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  }

  closeSidebar() {
    this.sidebarOpen = false;
  }
}
